import React, { Fragment, useContext, useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LoginForm from "../../components/forms/LoginForm";
import RegisterForm from "../../components/forms/RegisterForm";
import OnlyLogoNavbar from "../../components/navbars/OnlyLogoNavbar";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";

const LoginAndRegister = () => {
    const { t } = useTranslation();
    const { checkServerData, setIsLogged, setAlerts, setShowView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);

    const handleLogin = async (data) => {
        const res = await postMethod("/login", {
            email: data.username,
            password: data.password,
            moduleName: "APP",
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.login"), fading: 1000, id: "login" }]);
            setIsLogged(res.data);
            setShowView({ nav: "schedule", sub: "main", params: { moduleName: "APP" } });
        }
        setBlockForm(false);
    };

    useEffect(() => {
        document.querySelectorAll("input").forEach((input) => {
            input.addEventListener("focus", (event) => {
                if (event.target.matches(":-webkit-autofill")) {
                    const value = input.value; // Tymczasowe zapisanie wartości
                    input.value = ""; // Wyczyszczenie pola
                    input.value = value; // Przywrócenie wartości (odświeżenie)
                }
            });
        });

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <OnlyLogoNavbar />
            <Container>
                <Row>
                    <Col xs={12} lg={6}>
                        <Row>
                            <Col xs={12}>
                                <h1 className="h4 p-4">{t("logIn")}</h1>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <LoginForm blockForm={blockForm} onBlockForm={setBlockForm} onLogin={handleLogin} />
                                </Row>
                            </Col>
                            <Col xs={12} className="d-none d-lg-block">
                                <div className="sticky-top" style={{ zIndex: 20 }}>
                                    <Image
                                        src={"/images/andzia.webp"}
                                        fluid
                                        alt="andzia w wysokich butach wygina się przy rurce zarzucając włosami. Autor fotografia: Ania i 40 obiektywów."
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} className="d-lg-none">
                        <hr />
                    </Col>

                    <Col xs={12} lg={6}>
                        <Row>
                            <Col xs={12}>
                                <h1 className="h4 py-4">{t("registerForm.title")}</h1>
                            </Col>
                            <Col xs={12}>
                                <RegisterForm blockForm={blockForm} onBlockForm={setBlockForm} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default LoginAndRegister;
